import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../../../hooks/useAuth";
import { createApi, getUserApi, removeFileApi, showUsersByRoleApi, updateUserApi } from "../../../../services/Admin/user";
import { getApiOrganizationDetails } from "../../../../services/Admin/organizations";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Services from "./Services";
import AssignedZones from "./AssignedZones";
import BillingInformation from "./BillingInformation";
import Availability from "./Availability";
import Absences from "./Absences";
import { impersonateApi } from "../../../../services/Auth/impersonate";
import jwtDecode from "jwt-decode";
import { RouteAdmin } from "../../../../routes/RouteAdmin";
import { RouteUser } from "../../../../routes/RouteUser";
import Card from "../../../../components/Admin/Card";

export default function Fields() {

    const { id } = useParams()
    const history = useNavigate()
    const { auth, login } = useAuth()


    const [msgSuccess, setMsgSuccess] = useState(false)
    const [msgDanger, setMsgDanger] = useState(null)
    const [loading, setLoading] = useState(true)

    const [showZoneBlock, setShowZoneBlock] = useState(false)
    const [showInfo, setShowInfo] = useState(false)
    const [showAdjunto, setShowAdjunto] = useState(false)
    const [showInvoiceBlock, setShowInvoiceBlock] = useState(false)
    const [showServiceBlock, setShowServiceBlock] = useState(false)
    const [showServicePvp, setShowServicePvp] = useState(false)
    const [showWorkerBlock, setShowWorkerBlock] = useState(false)
    const [showButtonsFile, setShowButtonsFile] = useState(false)

    // Organización
    const [maxUserRoleWorkers, setMaxUserRoleWorkers] = useState(0)
    const [userWorker, setUserWorker] = useState(0)

    const listRoleAll = [
        { id: 1, key: "ROLE_ADMIN", name: "Admin" },
        { id: 2, key: "ROLE_CLIENT", name: "Cliente" },
        { id: 3, key: "ROLE_WORKER", name: "Trabajador" },
        { id: 4, key: "ROLE_MANAGER", name: "Gestor" },
        { id: 5, key: "ROLE_IA_CONNECTOR", name: "Conector IA" },
    ]

    const listRole = [
        { id: 2, key: "ROLE_CLIENT", name: "Cliente" },
        { id: 3, key: "ROLE_WORKER", name: "Trabajador" },
        { id: 4, key: "ROLE_MANAGER", name: "Gestor" },
        { id: 5, key: "ROLE_IA_CONNECTOR", name: "Conector IA" },
    ]

    const [defaultRole, setDefaultRole] = useState([]);

    const [defaultRegionInvoiceValueList, setDefaultRegionInvoiceValueList] = useState({})
    const [defaultMunicipioInvoiceValueList, setDefaultMunicipioInvoiceValueList] = useState({})
    const [defaultProvinceInvoiceValueList, setDefaultProvinceInvoiceValueList] = useState({})
    const [defaultComarcaInvoiceValueList, setDefaultComarcaInvoiceValueList] = useState({})
    const [defaultCountryInvoiceValueList, setDefaultCountryInvoiceValueList] = useState({})
    const [userServicesId, setUserServicesId] = useState([])

    const [uploadBin, setUploadBin] = useState(null)

    const [initialValues, setInitialValues] = useState(defaultValues())

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object(validationSchema(defaultRole)),
        enableReinitialize: true,
        onSubmit: async () => {
            setMsgSuccess(false)
            setMsgDanger(null)

            let f = new FormData()
            for (const property in formik.values) {
                if (typeof (formik.values[property]) === 'object') {
                    f.append(`${property}`, JSON.stringify(formik.values[property]))
                } else {
                    f.append(`${property}`, formik.values[property])
                }
            }
            if (uploadBin) {
                f.append("upload", uploadBin[0])
            }


            if (id) {
                updateUserApi(f).then(resp => {
                    if (resp.data?.status) {
                        setMsgSuccess(true)
                    } else {
                        setMsgDanger(resp?.errors)
                    }
                }).catch(err => {
                    setMsgDanger(err?.response?.data?.errors)
                })
            } else {
                createApi(f).then(resp => {
                    if (resp?.data.status) {
                        history(RouteAdmin.USER_MANAGEMENT.path)
                    } else {
                        setMsgDanger(resp?.data.errors)
                    }
                }).catch(err => {
                    setMsgDanger(err?.response?.data?.errors)
                })
            }

        },
    })

    useEffect(() => {
        if (formik.values.idUserRole) {
            switch (formik.values.idUserRole.key) {
                case "ROLE_WORKER":
                    setShowInfo(false)
                    setShowAdjunto(false)
                    setShowInvoiceBlock(false)
                    setShowServiceBlock(true)
                    setShowServicePvp(false)
                    setShowZoneBlock(true)
                    setShowWorkerBlock(true)
                    break;
                case "ROLE_CLIENT":
                    setShowInfo(true)
                    setShowAdjunto(true)
                    setShowInvoiceBlock(true)
                    setShowServiceBlock(true)
                    setShowServicePvp(true)
                    setShowZoneBlock(true)
                    setShowWorkerBlock(false)
                    break;
                case "ROLE_MANAGER":
                    setShowInfo(false);
                    setShowAdjunto(false)
                    setShowInvoiceBlock(false)
                    setShowServiceBlock(false)
                    setShowServicePvp(false)
                    setShowZoneBlock(false)
                    setShowWorkerBlock(false)
                    break;
                default:  // ROLE_WORKER 
                    setShowInfo(false);
                    setShowAdjunto(false)
                    setShowInvoiceBlock(false)
                    setShowServiceBlock(false)
                    setShowServicePvp(false)
                    setShowZoneBlock(false)
                    setShowWorkerBlock(false)
                    break;
            }
        } else { // Default Admin
            setShowInfo(false);
            setShowAdjunto(false)
            setShowInvoiceBlock(false)
            setShowServiceBlock(false)
            setShowServicePvp(false)
            setShowZoneBlock(false)
            setShowWorkerBlock(false)
        }
    }, [formik.values.idUserRole]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        getUser()
        getOrganizationDetails()
        setLoading(false)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    // Llamamos a la API para obtener los datos del usuario
    const getUser = async () => {
        if (id) {
            getUserApi(id).then(response => {

                // Añade ${organizationId}_precioFijo y ${organizationId}_totalFijo a initialValues
                response.data.data.organizations.forEach(org => {
                    response.data.data[`organizationId_${org.id}_precioFijo`] = org.precioFijo;
                    response.data.data[`organizationId_${org.id}_totalFijo`] = org.totalFijo;
                });

                // Afegim el símbol # al color
                if (response.data.data.color && response.data.data.color[0] !== "#") {
                    response.data.data.color = "#" + response.data.data.color
                }

                setInitialValues({
                    ...response.data.data
                })

                if (response.data.data.file) {
                    setShowButtonsFile(true)
                }

                setDefaultRole(response.data.data.idUserRole)

                const payload = response.data.data;
                const grouped = {};

                Object.keys(payload).forEach(key => {
                    if (key.startsWith("service_org")) {
                        const m = key.match(/^service_org(\d+)_id(\d+)$/);
                        if (m) {
                            const orgId = parseInt(m[1], 10);
                            const serviceId = parseInt(m[2], 10);
                            const valueRaw = payload[key];

                            if (!grouped[orgId]) grouped[orgId] = {};
                            // guardem null si no està contractat
                            grouped[orgId][serviceId] = valueRaw === "" ? null : Number(valueRaw);
                        }
                    }
                });

                setUserServicesId(grouped);

                setDefaultRegionInvoiceValueList(response.data.data.idRegionInvoice)
                setDefaultProvinceInvoiceValueList(response.data.data.idProvinceInvoice)
                setDefaultMunicipioInvoiceValueList(response.data.data.idMunicipioInvoice)
                setDefaultComarcaInvoiceValueList(response.data.data.idComarcaInvoice)
                setDefaultCountryInvoiceValueList(response.data.data.idCountryInvoice)

            }).catch(error => {
                console.error(error)
            })
        }
    }

    const clickImpersonate = async () => {
        setMsgDanger(null)
        setMsgSuccess(false)

        impersonateApi({
            id: id
        }).then(resp => {
            if (resp.data.status) {
                impersonate(resp.data?.token)
            } else {
                setMsgDanger(resp?.errors)
            }
        }).catch(err => {
            setMsgDanger(err?.response?.data?.errors)
        })
    }

    const impersonate = async (token) => {
        await login({
            primaryUser: token,
            secondaryUser: auth?.secondaryUser,
        })
        switch (jwtDecode(token).roles[0]) {
            case "ROLE_WORKER":
                history(RouteUser.WORKER_CALENDAR.path)
                break
            case "ROLE_CLIENT":
                history(RouteUser.MY_ACCOUNT_CLIENT.path)
                break
            case "ROLE_MANAGER":
                history(RouteAdmin.CALENDARIO_MANAGEMENT.path)
                break
            case "ROLE_ADMIN":
                history(RouteAdmin.CALENDARIO_MANAGEMENT.path)
                break
            default:
                history("/login");
        }
    }

    const removeFile = async () => {
        removeFileApi(id).then(resp => {
            if (resp.data.status) {
                setShowButtonsFile(false)
            }
        })
    }

    const getOrganizationDetails = async () => {
        getApiOrganizationDetails().then(res => {
            setMaxUserRoleWorkers(res.data.max_user_role_workers)
            setUserWorker(res.data.userWorker)
        })
    }

    if (loading) return ""

    return (
        <Card>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12}>
                        <h1 className="p-0">Configuraciones de la cuenta</h1>
                    </Grid>
                </Grid>

                {msgSuccess && (
                    <Grid item xs={12} md={12} lg={12}>
                        <Box className="alert-success">
                            Los datos del usuario se han guardado correctamente
                        </Box>
                    </Grid>
                )}

                {msgDanger && (
                    <Grid item xs={12} md={12} lg={12}>
                        <Box className="alert-danger">
                            {msgDanger.map((item) => {
                                return (<span>{item} <br /></span>)
                            })}
                        </Box>
                    </Grid>
                )}

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={6}>
                        <Box border={1} className="p-20 box-default">
                            <Grid container spacing={3}>
                                <Grid item md={12}>
                                    <div style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                                        <div>
                                            <h4 className="p-0 mt-0">Ajustes</h4>
                                        </div>
                                        {id && (
                                            <div>
                                                <TextField
                                                    variant="outlined"
                                                    label="* Identificador de usuario"
                                                    className="form-control"
                                                    name="name"
                                                    type="text"
                                                    value={formik.values.id || ""}
                                                    onChange={formik.handleChange}
                                                    disabled
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    size="small"
                                                />
                                            </div>
                                        )}

                                        <div>
                                            <TextField
                                                variant="outlined"
                                                label="* Nombre"
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                value={formik.values.name || ""}
                                                onChange={formik.handleChange}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                size="small"
                                            />
                                            {formik.errors.name && (
                                                <p className="text-100 text-danger mt-1">
                                                    {formik.errors.name}
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <TextField
                                                variant="outlined"
                                                label="* Apellidos"
                                                className="form-control"
                                                name="surnames"
                                                type="text"
                                                value={formik.values.surnames || ""}
                                                onChange={formik.handleChange}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                size="small"
                                            />
                                            {formik.errors.surnames && (
                                                <p className="text-100 text-danger mt-1">
                                                    {formik.errors.surnames}
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <TextField
                                                variant="outlined"
                                                label="* Email"
                                                className="form-control"
                                                name="email"
                                                type="text"
                                                value={formik.values.email || ""}
                                                onChange={formik.handleChange}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                size="small"
                                            />
                                            {formik.errors.email && (
                                                <p className="text-100 text-danger mt-1">
                                                    {formik.errors.email}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </Grid>


                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <Box border={1} className="p-20 box-default">
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <div style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                                        <div>
                                            <h3 className="p-0 mt-0">Seguridad</h3>
                                            <p>
                                                Solo debe rellenar la contraseña en el caso de
                                                que la quiere modificar.
                                            </p>
                                            <p>
                                                Desactiva la opción de "Acceso a la
                                                plataforma" en caso de que desee bloquear el
                                                usuario.
                                            </p>
                                        </div>
                                        <div>
                                            <Autocomplete
                                                name="idUserRoleList"
                                                options={auth?.primaryUser?.isSuperAdmin ? listRoleAll : listRole}
                                                value={defaultRole}
                                                getOptionLabel={(option) =>
                                                    option.name ? option.name : ""
                                                }
                                                getOptionSelected={(option, value) =>
                                                    option.value === value.value || ""
                                                }
                                                onChange={(event, newValue) => {
                                                    if (newValue !== null) {
                                                        formik.values.idUserRole = newValue;
                                                        setDefaultRole(newValue)
                                                    } else {
                                                        formik.values.idUserRole = null;
                                                        setDefaultRole({})
                                                    }
                                                }}
                                                fullWidth
                                                size="small"
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="* Tipo de usuario (Rol)"
                                                        name="idUserRole"
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                            {formik.values.idUserRole && formik.values.idUserRole.key === "ROLE_WORKER" && userWorker >= maxUserRoleWorkers && !id ? (
                                                <p className="text-100 text-danger mt-1">
                                                    Ya tiene el máximo número de trabajadores permitidos en su plan actual ({maxUserRoleWorkers}). Si desea añadir más trabajadores, por favor, contacte con nosotros.
                                                </p>
                                            ) : null}
                                        </div>

                                        <div>
                                            <TextField
                                                name="password"
                                                value={formik.values.password || ""}
                                                onChange={formik.handleChange}
                                                label="Contraseña"
                                                className="form-control"
                                                size="small"
                                                type="password"
                                                inputProps={{
                                                    autoComplete: "new-password",
                                                    form: {
                                                        autoComplete: "off",
                                                    },
                                                }}
                                                variant="outlined"

                                                fullWidth

                                            />
                                            {formik.errors.password && (
                                                <p className="text-100 text-danger mt-1">
                                                    {formik.errors.password}
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={formik.values.isActive || ""}
                                                        onChange={formik.handleChange}
                                                        name="isActive"
                                                        color="primary"
                                                    />
                                                }
                                                label="Acceso a la plataforma"
                                            />
                                        </div>
                                        {id && (
                                            <div>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    type="button"
                                                    fullWidth
                                                    onClick={clickImpersonate}
                                                >
                                                    Impersonar
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>

                    {showInvoiceBlock && (
                        <Grid item xs={12} md={12} lg={12}>
                            <BillingInformation
                                formik={formik}
                                defaultRegionInvoiceValueList={defaultRegionInvoiceValueList}
                                municipalyDefault={defaultMunicipioInvoiceValueList}
                                provinceDefault={defaultProvinceInvoiceValueList}
                                setDefaultMunicipioInvoiceValueList={setDefaultMunicipioInvoiceValueList}
                                setDefaultProvinceInvoiceValueList={setDefaultProvinceInvoiceValueList}
                                setDefaultRegionInvoiceValueList={setDefaultRegionInvoiceValueList}
                                defaultComarcaInvoiceValueList={defaultComarcaInvoiceValueList}
                                setDefaultComarcaInvoiceValueList={setDefaultComarcaInvoiceValueList}
                                defaultCountryInvoiceValueList={defaultCountryInvoiceValueList}
                                setDefaultCountryInvoiceValueList={setDefaultCountryInvoiceValueList}
                            />
                        </Grid>
                    )}
                </Grid>

                {showWorkerBlock && (

                    <Box border={1} className="p-20 mt-2 box-default">
                        <Grid container spacing={3}>
                            <Grid item md={6}>
                                <div style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                                    <div>
                                        <h4 className="p-0 mt-0">Datos del trabajador</h4>
                                        <p>
                                            - Introduzca DNI / CIF y los datos adicionales
                                        </p>
                                    </div>
                                    <div>
                                        <TextField
                                            variant="outlined"
                                            label="* DNI/CIF"
                                            className="form-control"
                                            name="dni"
                                            type="text"
                                            value={formik.values.dni}
                                            onChange={formik.handleChange}
                                            fullWidth
                                            size="small"
                                        />
                                        {formik.errors.dni && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.dni}
                                            </p>
                                        )}
                                    </div>
                                    <div>
                                        <TextField
                                            variant="outlined"
                                            label="* Número de cuenta bancaria"
                                            className="form-control"
                                            name="cc"
                                            type="text"
                                            value={formik.values.cc}
                                            onChange={formik.handleChange}
                                            fullWidth
                                            size="small"
                                        />
                                        {formik.errors.cc && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.cc}
                                            </p>
                                        )}
                                    </div>
                                    <div>
                                        <TextField
                                            variant="outlined"
                                            label="* Telefono"
                                            className="form-control"
                                            name="phone"
                                            type="text"
                                            value={formik.values.phone}
                                            onChange={formik.handleChange}
                                            fullWidth
                                            size="small"
                                        />
                                        {formik.errors.phone && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.phone}
                                            </p>
                                        )}
                                    </div>
                                    {/* Tipo de jornada, horas semanales contratadas y margen entre
                                        servicios se movieron al bloque "Disponibilidad horaria"
                                        (Availability.js) */}
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <TextField
                                            variant="outlined"
                                            label="Alta como trabajador"
                                            className="form-control"
                                            name="contractStartDate"
                                            type="date"
                                            value={formik.values.contractStartDate || ""}
                                            onChange={formik.handleChange}
                                            fullWidth
                                            size="small"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            variant="outlined"
                                            label="Baja como trabajador"
                                            className="form-control"
                                            name="contractEndDate"
                                            type="date"
                                            value={formik.values.contractEndDate || ""}
                                            onChange={formik.handleChange}
                                            fullWidth
                                            size="small"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                            <Grid item md={6}>
                                <div style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                                    <div style={{ height: "75px" }}></div>
                                    <div>
                                        <TextField
                                            variant="outlined"
                                            label="* Color trabajador"
                                            className="form-control"
                                            name="color"
                                            type="color"
                                            value={formik.values.color}
                                            onChange={formik.handleChange}
                                            fullWidth
                                            size="small"
                                        />
                                        {formik.errors.color && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.color}
                                            </p>
                                        )}
                                    </div>

                                    <div>
                                        <TextField
                                            name="info"
                                            label="Observaciones"
                                            multiline
                                            rows={4}
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={formik.values.info || ""}
                                            onChange={formik.handleChange}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>

                )}

                <AssignedZones
                    formik={formik}
                    showInfo={showInfo}
                    showZoneBlock={showZoneBlock}
                />
                <Availability
                    formik={formik}
                    showWorkerBlock={showWorkerBlock}
                />
                <Absences
                    formik={formik}
                    showWorkerBlock={showWorkerBlock}
                />
                {showAdjunto && (

                    <Box border={1} className="p-20 mt-2 box-default">
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                                <h3 className="p-0 mt-0">Documentación adicional</h3>
                                <p>
                                    - Adjuntar información adicional
                                </p>

                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    variant="outlined"
                                    label="Documento para subir ..."
                                    className="form-control"
                                    type="file"
                                    onChange={(event) => {
                                        setUploadBin(event.target.files)
                                    }}
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>

                                {showButtonsFile && (
                                    <>
                                        <div className="my-2 text-center">
                                            <Button
                                                type="button"
                                                variant="contained"
                                                color="primary"
                                                href={formik.values.file || ""}
                                                target="_blank"
                                                fullWidth
                                            >
                                                Ver archivo
                                            </Button>
                                        </div>

                                        <div className="my-2 text-center">
                                            <Button
                                                type="button"
                                                variant="contained"
                                                target="_blank"
                                                fullWidth
                                                onClick={removeFile}
                                            >
                                                Eliminar archivo
                                            </Button>
                                        </div>
                                    </>
                                )}
                            </Grid>

                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    variant="outlined"
                                    label="* Número de cuenta bancaria"
                                    className="form-control"
                                    name="cc"
                                    type="text"
                                    value={formik.values.cc}
                                    onChange={formik.handleChange}
                                    fullWidth
                                    size="small"
                                />
                                {formik.errors.cc && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.cc}
                                    </p>
                                )}
                            </Grid>
                            <Grid item xs={12} md={6} lg={6} />

                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    name="observaciones"
                                    label="Observaciones"
                                    multiline
                                    rows={3}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    value={formik.values.observaciones || ""}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                        </Grid>
                    </Box>
                )}

                {(formik?.values?.organizations && formik?.values?.organizations.length > 0)
                    ? formik.values.organizations.map((org) => (
                        <Services
                            formik={formik}
                            userServicesId={userServicesId}
                            showServiceBlock={showServiceBlock}
                            showServicePvp={showServicePvp}
                            organizationName={org.name}
                            organizationId={org.id}
                            key={org.id}
                        />
                    ))
                    : (
                        <Services
                            formik={formik}
                            userServicesId={userServicesId}
                            showServiceBlock={showServiceBlock}
                            showServicePvp={showServicePvp}
                            organizationName={auth?.primaryUser?.organizationName}
                            organizationId={auth?.primaryUser?.organizationId}
                            key={auth?.primaryUser?.organizationId}
                        />
                    )
                }

                <Grid container spacing={3}>
                    <Grid item md={12}>
                        <br />
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <div style={{ width: 200 }}>
                                <Button
                                    type="button"
                                    href="/dash-admin/users/management"
                                    fullWidth
                                    variant="contained"
                                    className="MuiButton-containedCancel"
                                >
                                    Cancelar
                                </Button>
                            </div>
                            <div style={{ width: 200, marginLeft: 20 }}>
                                <Button
                                    disabled={formik.values.idUserRole && formik.values.idUserRole.key === "ROLE_WORKER" && userWorker >= maxUserRoleWorkers && !id}
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    fullWidth
                                >
                                    Guardar
                                </Button>
                            </div>
                        </div>
                        <br />
                    </Grid>
                </Grid>
            </form>
        </Card>
    )
}

function defaultValues() {
    return {
        id: "",
        name: "",
        surnames: "",
        email: "",

        invRazonSocial: "",
        dni: "",
        invAddress: "",
        invCp: "",
        idMunicipalityInvoice: null,
        idProvinceInvoice: null,
        facturacionAutomatica: true,
        mostrarPrecioFactura: false,
        emailFacturacion: "",

        color: "",
        phone: "",
        cc: "",
        observaciones: "",

        jornadaType: "",
        weeklyContractedHours: "",
        serviceMarginMinutes: "",
        contractStartDate: "",
        contractEndDate: "",
        availability: null,
        absences: null,

        info: "",
        idComarca: null,
        idMunicipalityList: null,
        idUserRole: [],
        password: "",

        idService: null,
        precioFijo: false,
        totalFijo: "",
        isActive: true
    }
}

function validationSchema(defaultRole) {

    if (defaultRole['id'] !== undefined) {

        if (defaultRole['id'] === 1 || defaultRole['id'] === 4 || defaultRole['id'] === 5) {
            return {
                id: Yup.number(),
                name: Yup.string().required("El nombre es obligatorio"),
                surnames: Yup.string().required("Los apellidos son obligatorios"),
                email: Yup.string()
                    .email("El email no es correcto")
                    .required("El email es obligatorio"),
                password: Yup.string(),
                idUserRole: Yup.object({
                    id: Yup.number().required(),
                    key: Yup.string().required(),
                    name: Yup.string().required()
                }).required("El tipo de rol es obligatorio").nullable(),
            }
        } else if (defaultRole['id'] === 2) {
            return {
                id: Yup.number(),
                name: Yup.string().required("El nombre es obligatorio"),
                surnames: Yup.string().required("Los apellidos son obligatorios"),
                email: Yup.string()
                    .email("El email no es correcto")
                    .required("El email es obligatorio"),
                password: Yup.string(),
                idUserRole: Yup.object({
                    id: Yup.number().required(),
                    key: Yup.string().required(),
                    name: Yup.string().required()
                }).required("El tipo de rol es obligatorio").nullable(),
                invRazonSocial: Yup.string().required("La razón social es obligatoria"),
                dni: Yup.string().required("El DNI/CIF es obligatorio"),
                invAddress: Yup.string().required("La dirección de facturación es obligatoria"),
                info: Yup.string().required("La dirección es obligatoria"),
                invCp: Yup.string().required("El código postal es obligatorio"),
                //idMunicipalityInvoice: Yup.object().typeError("El municipio es obligatorio").required("El municipio es obligatorio"),
                //idProvinceInvoice: Yup.object().typeError("La provincia es obligatoria").required("La provincia es obligatoria"),
                phone: Yup.string().nullable().required("El teléfono es obligatorio"),
                emailFacturacion: Yup.string()
                    .email("El email de facturación no es correcto")
                    .required("El email de facturación es obligatorio"),
            }

        } else {
            return {
                id: Yup.number(),
                name: Yup.string().required("El nombre es obligatorio"),
                surnames: Yup.string().required("Los apellidos son obligatorios"),
                email: Yup.string()
                    .email("El email no es correcto")
                    .required("El email es obligatorio"),
                password: Yup.string(),
                idUserRole: Yup.object({
                    id: Yup.number().required(),
                    key: Yup.string().required(),
                    name: Yup.string().required()
                }).required("El tipo de rol es obligatorio").nullable(),
                dni: Yup.string().required("El DNI/CIF es obligatorio"),
                phone: Yup.string().nullable().required("El teléfono es obligatorio"),
                weeklyContractedHours: Yup.number().nullable().typeError("Las horas contratadas deben ser un número").min(0, "Las horas contratadas no pueden ser negativas"),
                serviceMarginMinutes: Yup.number().nullable().typeError("El margen debe ser un número").min(0, "El margen no puede ser negativo"),
            }

        }

    } else {
        return {
            id: Yup.number(),
            name: Yup.string().required("El nombre es obligatorio"),
            surnames: Yup.string().required("Los apellidos son obligatorios"),
            email: Yup.string()
                .email("El email no es correcto")
                .required("El email es obligatorio"),
            password: Yup.string(),
            idUserRole: Yup.object({
                id: Yup.number().required(),
                key: Yup.string().required(),
                name: Yup.string().required()
            }).required("El tipo de rol es obligatorio").nullable(),
        }
    }
}
